export const MINI_QUIZ_UID = "MjY1";
export const MINI_QUIZ_NAME = "Mini Quiz";
export const MINI_QUIZ_RESULT_PATH = "/dosha-quiz/mini-result";
export const MINI_QUIZ_PATH = `/dosha-quiz/${MINI_QUIZ_UID}`;
export const FULL_DOSHA_ASSESSMENT_UID = "MTY5";
export const FULL_DOSHA_ASSESSMENT_BASE_URL = `https://quiz.maharishiayurveda.de/dosha-quiz/${FULL_DOSHA_ASSESSMENT_UID}`;
export const DOSHA_QUIZ_FAVICON_URL =
  "https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://maharishiayurvedaindia.com&size=64";
export const MINI_QUIZ_COMPLETED_KEY = "miniDoshaCompleted_MjY1";
export const DEFAULT_MINI_QUIZ_LANGUAGE = "English";
export const MINI_QUIZ_FORM_LEFT_IMAGE = "/miniquiz_en.jpeg";

export const getFullDoshaAssessmentUrl = (language = DEFAULT_MINI_QUIZ_LANGUAGE) => {
  const url = new URL(FULL_DOSHA_ASSESSMENT_BASE_URL);
  if (language) {
    url.searchParams.set("language", language);
  }
  return url.toString();
};

const MONTH_OPTIONS_EN = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const MONTH_OPTIONS_DE = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember",
];

const buildContentManagements = (language, months) => [
  {
    id: 34,
    content_type: "language",
    title: language === "Deutsch" ? "Sprache" : "Language",
    name: "language",
    description: language === "Deutsch" ? "Sprache wählen" : "select language",
    error_message: "",
    is_required: true,
    urls: "",
    sequence: 1,
    col_span: "",
    attachment_url: null,
    options: [
      { id: 29, option: "English", sequance: 1 },
      { id: 30, option: "Deutsch", sequance: 2 },
    ],
  },
  {
    id: 98,
    content_type: "text",
    title: language === "Deutsch" ? "Name" : "Name ",
    name: "name",
    description: language === "Deutsch" ? "Vollständigen Namen eingeben" : "Enter Your Full Name",
    error_message: language === "Deutsch" ? "Name ist erforderlich" : "Name is Required",
    is_required: true,
    urls: "",
    sequence: 2,
    col_span: "",
    attachment_url: null,
    options: [],
  },
  {
    id: 99,
    content_type: "email",
    title: language === "Deutsch" ? "E-Mail-Adresse" : "Email Address",
    name: "email",
    description: language === "Deutsch" ? "E-Mail-Adresse eingeben" : "Enter your email address",
    error_message: language === "Deutsch" ? "E-Mail ist erforderlich" : "Email is required",
    is_required: true,
    urls: "",
    sequence: 3,
    col_span: "",
    attachment_url: null,
    options: [],
  },
  {
    id: 101,
    content_type: "date-of-birth",
    title: language === "Deutsch" ? "Geburtsdatum" : "Date of Birth",
    name: "dob",
    description: language === "Deutsch" ? "Monat , Tag, Jahr" : "Month , Day, Year",
    error_message: language === "Deutsch" ? "Bitte wählen Sie Ihr vollständiges Geburtsdatum." : "Please select your full date of birth.",
    is_required: false,
    urls: "",
    sequence: 5,
    col_span: "",
    attachment_url: null,
    options: months.map((option, index) => ({
      id: 40 + index,
      option,
      sequance: index + 1,
    })),
  },
  {
    id: 102,
    content_type: "privacypolicy",
    title: language === "Deutsch" ? "Datenschutzerklärung" : "Privacy Policy",
    name: "privacypolicy",
    description:
      language === "Deutsch"
        ? "Ich habe die <Datenschutzerklärung> gelesen und stimme der Verarbeitung meiner personenbezogenen Daten gemäß den Datenschutzrichtlinien zu."
        : "I have read the <privacy policy> and agree to the processing of my personal data in accordance with the privacy guidelines.",
    error_message:
      language === "Deutsch"
        ? "Sie müssen die Datenschutzerklärung akzeptieren"
        : "You must accept the privacy policy",
    is_required: true,
    urls: "https://maharishiayurveda.de/pages/datenschutz",
    sequence: 0,
    col_span: "",
    attachment_url: null,
    options: [],
  },
];

export const MINI_QUIZ_LOCALES = {
  English: {
    contentManagements: buildContentManagements("English", MONTH_OPTIONS_EN),
    category: {
      id: 199,
      name: "Mini quiz",
      description: "",
      questions: [
        {
          id: 331,
          content: "How would you describe your natural energy?",
          sequance: 1,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. It comes in waves—sometimes high, sometimes low, but always creative." },
            { key: "B", dosha: "pitta", label: "B. Strong, focused, and ready to achieve goals." },
            { key: "C", dosha: "kapha", label: "C. Steady, calm, and dependable throughout the day." },
          ],
        },
        {
          id: 332,
          content: "What motivates you most?",
          sequance: 2,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. New experiences and fresh ideas." },
            { key: "B", dosha: "pitta", label: "B. Success, progress, and accomplishing goals." },
            { key: "C", dosha: "kapha", label: "C. Meaningful relationships and a sense of stability." },
          ],
        },
        {
          id: 333,
          content: "When you enter a room, people often notice that you are:",
          sequance: 3,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. Enthusiastic, expressive, and full of ideas." },
            { key: "B", dosha: "pitta", label: "B. Confident, driven, and energetic." },
            { key: "C", dosha: "kapha", label: "C. Warm, calm, and easy to be around." },
          ],
        },
        {
          id: 334,
          content: "How do you recharge your energy?",
          sequance: 4,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. Through creativity, exploration, or trying something new." },
            { key: "B", dosha: "pitta", label: "B. By accomplishing tasks and staying productive." },
            { key: "C", dosha: "kapha", label: "C. Through rest, nature, and quality time with loved ones." },
          ],
        },
        {
          id: 335,
          content: "Which statement sounds most like you?",
          sequance: 5,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: 'A. "I love freedom, variety, and inspiration."' },
            { key: "B", dosha: "pitta", label: 'B. "I enjoy challenges and strive to be my best."' },
            { key: "C", dosha: "kapha", label: 'C. "I value balance, comfort, and supporting others."' },
          ],
        },
      ],
    },
    results: {
      vata: {
        key: "A",
        name: "VATA",
        elements: "Air + Space",
        headline: "VATA",
        description: "Creative, imaginative, and adaptable. You thrive on inspiration, new experiences, and fresh perspectives.",
        keywordsLabel: "Your Energy Keywords:",
        keywords: ["Creative", "Curious", "Flexible", "Visionary"],
      },
      pitta: {
        key: "B",
        name: "PITTA",
        elements: "Fire + Water",
        headline: "PITTA",
        description: "Focused, ambitious, and purpose-driven. You naturally lead, take action, and turn ideas into results.",
        keywordsLabel: "Your Energy Keywords:",
        keywords: ["Driven", "Confident", "Determined", "Dynamic"],
      },
      kapha: {
        key: "C",
        name: "KAPHA",
        elements: "Earth + Water",
        headline: "KAPHA",
        description: "Calm, nurturing, and grounded. You bring stability, patience, and strength to every situation.",
        keywordsLabel: "Your Energy Keywords:",
        keywords: ["Steady", "Compassionate", "Loyal", "Resilient"],
      },
    },
    ui: {
      pageTitle: "Which Vital Force Governs You?",
      pageDescription: "Which Vital Force Governs You? Choose the option that best describes you.",
      introSubtitle: "Which Vital Force Governs You?",
      introInstructions: "Choose the option that best describes you.",
      continueToQuiz: "Continue to Quiz",
      loading: "Loading...",
      questionOf: "Question",
      of: "of",
      selectResponseTooltip: "Please select a response to proceed",
      previousQuestion: "Previous",
      nextQuestion: "Next",
      submitQuiz: "Submit Quiz",
      submittingQuiz: "Submitting Quiz...",
      resultTitle: "Which Vital Force Governs You?",
      resultGreeting: (name) => `Hi ${name}, here is your energy profile.`,
      ctaLead: "Ready to discover your complete Ayurvedic profile?",
      ctaButton: "Take our Full Dosha Assessment",
      ctaNote: "for personalized wellness insights.",
      dobMonth: "Month",
      dobDay: "Day",
      dobYear: "Year",
    },
    loadingStates: [
      { text: "Reviewing your answers…" },
      { text: "Spotting your unique patterns…" },
      { text: "Figuring out your vital force…" },
      { text: "Personalizing your results…" },
      { text: "Almost done! Preparing your energy profile…" },
    ],
  },
  Deutsch: {
    contentManagements: buildContentManagements("Deutsch", MONTH_OPTIONS_DE),
    category: {
      id: 199,
      name: "Mini quiz",
      description: "",
      questions: [
        {
          id: 331,
          content: "Wie würdest du deine natürliche Energie beschreiben?",
          sequance: 1,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. Sie kommt in Wellen – manchmal hoch, manchmal niedrig, aber immer kreativ." },
            { key: "B", dosha: "pitta", label: "B. Stark, fokussiert und bereit, Ziele zu erreichen." },
            { key: "C", dosha: "kapha", label: "C. Beständig, ruhig und verlässlich im Tagesverlauf." },
          ],
        },
        {
          id: 332,
          content: "Was motiviert dich am meisten?",
          sequance: 2,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. Neue Erfahrungen und frische Ideen." },
            { key: "B", dosha: "pitta", label: "B. Erfolg, Fortschritt und das Erreichen von Zielen." },
            { key: "C", dosha: "kapha", label: "C. Bedeutungsvolle Beziehungen und ein Gefühl von Stabilität." },
          ],
        },
        {
          id: 333,
          content: "Wenn du einen Raum betrittst, fällt den Menschen oft auf, dass du:",
          sequance: 3,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. begeistert, ausdrucksstark und voller Ideen bist." },
            { key: "B", dosha: "pitta", label: "B. selbstbewusst, zielstrebig und energiegeladen bist." },
            { key: "C", dosha: "kapha", label: "C. warmherzig, gelassen und im Umgang mit anderen angenehm bist." },
          ],
        },
        {
          id: 334,
          content: "Wie lädst du deine Energie wieder auf?",
          sequance: 4,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. Durch Kreativität, Erkundung oder das Ausprobieren neuer Dinge." },
            { key: "B", dosha: "pitta", label: "B. Indem du Aufgaben erledigst und produktiv bleibst." },
            { key: "C", dosha: "kapha", label: "C. Durch Ruhe, Zeit in der Natur und wertvolle Momente mit den Liebsten." },
          ],
        },
        {
          id: 335,
          content: "Welche Aussage trifft am ehesten auf dich zu?",
          sequance: 5,
          answer_type: "radio_button",
          options: [
            { key: "A", dosha: "vata", label: "A. „Ich liebe Freiheit, Abwechslung und Inspiration.“" },
            { key: "B", dosha: "pitta", label: "B. „Ich genieße Herausforderungen und strebe danach, mein Bestes zu geben.“" },
            { key: "C", dosha: "kapha", label: "C. „Ich schätze Balance, Geborgenheit und das Unterstützen anderer.“" },
          ],
        },
      ],
    },
    results: {
      vata: {
        key: "A",
        name: "VATA",
        elements: "Luft + Raum",
        headline: "VATA",
        description: "Kreativ, einfallsreich und anpassungsfähig. Du gedeihst durch Inspiration, neue Erfahrungen und frische Perspektiven.",
        keywordsLabel: "Deine Energie-Schlüsselwörter:",
        keywords: ["Kreativ", "Neugierig", "Flexibel", "Visionär"],
      },
      pitta: {
        key: "B",
        name: "PITTA",
        elements: "Feuer + Wasser",
        headline: "PITTA",
        description: "Fokussiert, ehrgeizig und zielstrebig. Du führst von Natur aus, handelst und verwandelst Ideen in Ergebnisse.",
        keywordsLabel: "Deine Energie-Schlüsselwörter:",
        keywords: ["Angetrieben", "Selbstbewusst", "Entschlossen", "Dynamisch"],
      },
      kapha: {
        key: "C",
        name: "KAPHA",
        elements: "Erde + Wasser",
        headline: "KAPHA",
        description: "Ruhig, fürsorglich und geerdet. Du bringst Stabilität, Geduld und Stärke in jede Situation.",
        keywordsLabel: "Deine Energie-Schlüsselwörter:",
        keywords: ["Beständig", "Mitfühlend", "Loyal", "Belastbar"],
      },
    },
    ui: {
      pageTitle: "Welche Vitalenergie regiert dich am stärksten?",
      pageDescription: "Welche Vitalenergie regiert dich am stärksten? Wähle die Option, die dich am besten beschreibt.",
      introSubtitle: "Welche Vitalenergie regiert dich am stärksten?",
      introInstructions: "Wähle die Option, die dich am besten beschreibt.",
      continueToQuiz: "Weiter zum Test",
      loading: "Wird geladen...",
      questionOf: "Frage",
      of: "von",
      selectResponseTooltip: "Bitte wähle eine Antwort, um fortzufahren",
      previousQuestion: "Vorherige",
      nextQuestion: "Nächste",
      submitQuiz: "Test absenden",
      submittingQuiz: "Test wird gesendet...",
      resultTitle: "Welche Vitalenergie regiert dich am stärksten?",
      resultGreeting: (name) => `Hallo ${name}, hier ist dein Energieprofil.`,
      ctaLead: "Bereit, dein vollständiges ayurvedisches Profil zu entdecken?",
      ctaButton: "Voll-Dosha-Bewertung starten",
      ctaNote: "für personalisierte Wellness-Einblicke.",
      dobMonth: "Monat",
      dobDay: "Tag",
      dobYear: "Jahr",
    },
    loadingStates: [
      { text: "Antworten werden überprüft…" },
      { text: "Einzigartige Muster werden erkannt…" },
      { text: "Vitalenergie wird ermittelt…" },
      { text: "Ergebnisse werden personalisiert…" },
      { text: "Fast fertig! Energieprofil wird vorbereitet…" },
    ],
  },
};

export const getMiniQuizLocale = (language = DEFAULT_MINI_QUIZ_LANGUAGE) =>
  MINI_QUIZ_LOCALES[language] || MINI_QUIZ_LOCALES.English;

export const sortMiniQuizFormFields = (fields) =>
  [...fields]
    .map((field) => ({
      ...field,
      name: String(field.name || "").trim(),
    }))
    .sort((a, b) => {
      const tier = (field) => (field.content_type === "privacypolicy" ? 1 : 0);
      const tierA = tier(a);
      const tierB = tier(b);
      if (tierA !== tierB) return tierA - tierB;

      const aHasSequence = a.sequence !== undefined && a.sequence !== null && a.sequence > 0;
      const bHasSequence = b.sequence !== undefined && b.sequence !== null && b.sequence > 0;
      if (aHasSequence && bHasSequence) return a.sequence - b.sequence;
      if (aHasSequence) return -1;
      if (bHasSequence) return 1;
      return (Number(a.id) || 0) - (Number(b.id) || 0);
    });

/** @deprecated use getMiniQuizLocale(language).contentManagements */
export const MINI_QUIZ_CONTENT_MANAGEMENTS = MINI_QUIZ_LOCALES.English.contentManagements;

/** @deprecated use getMiniQuizLocale(language).category */
export const MINI_QUIZ_CATEGORIES = [MINI_QUIZ_LOCALES.English.category];

/** @deprecated use getMiniQuizLocale(language).results */
export const MINI_QUIZ_RESULTS = MINI_QUIZ_LOCALES.English.results;

/** @deprecated use getMiniQuizLocale(language).loadingStates */
export const MINI_QUIZ_LOADING_STATES = MINI_QUIZ_LOCALES.English.loadingStates;
